/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import PropTypes from 'prop-types';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import compose from 'lodash/fp/compose';
import { showElementCss } from '../../../../utils/responsive';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { defaultData } from '../data';
import { MediaQueries } from '../../../../styles/Grid';
import applyPluralRule from '../../../../utils/pluralRule';
import {
  atLocationTitleCss,
  statQuantityCss,
  statTitleCss,
  statWrapperCss,
  dividerCss,
  statsWrapperCss,
} from './index.styles';

const locationQtyHasValues = quantityArr => {
  return quantityArr.some(
    quantity => quantity.value && parseInt(quantity.value) > 0,
  );
};

class Stats extends SafePureComponent {
  renderLocation = locationsArr =>
    locationsArr.map((location, index) => {
      const quantityValue = parseInt(get(location, 'quantity.value', 0));
      if (quantityValue < 1) return null;

      const title = applyPluralRule({
        quantity: quantityValue,
        dictionary: location.title,
      });

      return (
        <div key={index} css={statWrapperCss}>
          <span
            className={`divider-${index}`}
            css={[dividerCss, showElementCss(MediaQueries.mdAndUp)]}
          />
          <p css={statQuantityCss}>
            <Text field={location.quantity} />
          </p>
          <p css={statTitleCss}>{title}</p>
        </div>
      );
    });

  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields, defaultData);
    const isEditing = get(props, 'sitecoreContext.pageEditing', false);
    const { t } = props;
    const {
      MeetingRoomsQuantity,
      CoworkingDesksQuantity,
      PrivateOfficesQuantity,
    } = fields;

    const quantityList = [
      PrivateOfficesQuantity,
      CoworkingDesksQuantity,
      MeetingRoomsQuantity,
    ];

    const locations = [
      {
        ['title']: 'PrivateOffices',
        ['quantity']: PrivateOfficesQuantity,
      },
      {
        ['title']: 'CoworkingDesks',
        ['quantity']: CoworkingDesksQuantity,
      },
      {
        ['title']: 'MeetingRooms',
        ['quantity']: MeetingRoomsQuantity,
      },
    ];

    return (
      <div>
        {(isEditing || locationQtyHasValues(quantityList)) && (
          <React.Fragment>
            <h2 css={atLocationTitleCss}>{t('AtThisLocationTitle')}</h2>
            <div css={statsWrapperCss}>{this.renderLocation(locations)}</div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

Stats.displayName = 'LocationHeader/Stats';

Stats.defaultProps = { fields: defaultData };

const objectPropShape = {
  value: PropTypes.string,
};

Stats.propTypes = {
  fields: PropTypes.shape({
    MeetingRoomsQuantity: PropTypes.shape(objectPropShape),
    CoworkingDesksQuantity: PropTypes.shape(objectPropShape),
    PrivateOfficesQuantity: PropTypes.shape(objectPropShape),
  }),
};

export default compose(withSitecoreContext(), withNamespaces())(Stats);
